/** @jsx jsx */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import { Container, Row, Col } from 'react-grid-system';
import FormContents from 'components/atoms/Form/FormContents';
import BodyText from 'components/atoms/BodyText';
import moment from 'moment';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import BlockUI from 'components/molecules/BlockUi';
import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import { css, jsx } from '@emotion/core';
import ToastModal from 'components/organismos/ToastModal';
import ConfirmModal from 'components/organismos/ConfirmModal';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import { PrimaryButton, DeleteButton } from 'components/atoms/Button';
import { textColor, textFontSize } from 'components/styles';
import Checkbox from 'components/molecules/Checkbox';
import useHolidayApplicationForm from './hooks';
import AttendHolidayApplicationDomain from 'domain/master/attend/holidayApplication';
import { Column } from 'react-table';
import Table from 'components/molecules/Table';
import AttendHolidayModal from 'components/molecules/ChangeLogModal/Template/AttendHolidayModal';
import HistoryApprovalTable from 'components/molecules/HistoryApprovalTable';
import FormPadding from 'components/atoms/Form/FormPadding';
import TabControl from 'components/atoms/TabControl';
import FormHeader from 'components/templates/FormHeader';

const styles = {
  hideByHolidayType1: (holidayType: number) => css({
    display: holidayType === 1 ? '' : 'none'
  }, styles.headerTitle),
  hideByHolidayType2: (holidayType: number) => css({
    display: holidayType === 2 ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType2Percent55: (holidayType: number) => css({
    display: holidayType === 2 ? '' : 'none',
    width: "55%"
  }, styles.headerTitle),
  hideByHolidayType1NotHalf: (holidayType: number, holidayUnit: number) => css({
    display: (holidayType === 1 && [3, 4].indexOf(holidayUnit) === -1) ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType1Half: (holidayType: number, holidayUnit: number) => css({
    display: (holidayType === 1 && [3, 4].indexOf(holidayUnit) !== -1) ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType4: (holidayType: number) => css({
    display: holidayType === 4 ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType4Percent55: (holidayType: number) => css({
    display: holidayType === 4 ? '' : 'none',
    width: "55%"
  }, styles.headerTitle),
  hideByHolidayType5: (holidayType: number) => css({
    display: holidayType === 5 ? '' : 'none',
    borderRight: 'none'
  }, styles.headerTitle),
  hideByHolidayType6: (holidayType: number) => css({
    display: holidayType === 6 ? '' : 'none',
  }, styles.headerTitle),
  hideWithType2: (holidayType: number, autograntholiday: boolean) => css({
    display: holidayType === 2 && autograntholiday ? '' : 'none',
  }, styles.headerTitle),
  hideWithType2NotAuto: (holidayType: number, autograntholiday: boolean) => css({
    display: holidayType === 2 && !autograntholiday ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType78: (holidayType: number) => css({
    display: ([7, 8].indexOf(holidayType) !== -1) ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType78NotHalf: (holidayType: number, holidayUnit: number) => css({
    display: ([7, 8].indexOf(holidayType) !== -1 && [3, 4].indexOf(holidayUnit) === -1) ? '' : 'none',
  }, styles.headerTitle),
  hideByHolidayType78Half: (holidayType: number, holidayUnit: number) => css({
    display: ([7, 8].indexOf(holidayType) !== -1 && [3, 4].indexOf(holidayUnit) !== -1) ? '' : 'none',
  }, styles.headerTitle),
  rangeTimeHalfDay: css({
    width: '600px',
  }),
  headerTitle: css({
    textAlign: 'center'
  }),
  formContent: {
    paddingBottom: '20px'
  },
  container: {
    marginTop: '30px'
  },
  approvalWrap: css({
    padding: '0px',
    marginBottom: '15px',
    marginTop: '0px'
  }),
};

enum ActionType {
  Add = 0,
  Modify = 1,
  Delete = 2,
}

const HolidayApplicationPage: React.FC = () => {
  const history = useHistory();
  const {
    isLoading,
    formik, targetDate, weekDay, staffName, holidayOptions,
    holidayUnitOptions, hourFormOptions,
    timeFormOptions,
    toastModalOpen,
    toastMessage,
    closeConfirmModal,
    confirmModalOpen,
    setToastModalOpen,
    currentApplid,
    selectedHoliday,
    holidays,
    setSelectedHoliday,
    substituteOptions,
    selectedSubstitute,
    setSelectedSubstitute,
    attendHolidayList,
    setHolidayUnitOptions,
    getHolidayUnitOption,
    holidayList,
    selectChangelog,
    setSelectChangelog,
    fetchChangeLogHoliday,
    substituteList,
    holidayStartDate,
	  holidayEndDate
  } = useHolidayApplicationForm();

  const [changeLogData, setChangeLogData] = useState<Array<any>>([]);

  useEffect(() => { 
    if (currentApplid) {
      fetchChangeLogHoliday(currentApplid.modifierApplicationId).then(res => {
        setChangeLogData(res);
      });
    }
  }, [currentApplid]);

  useEffect(() => {
    if (formik.values.holidayUnit !== 2) {
      formik.setFieldValue('startHour', "00");
      formik.setFieldValue('startTime', "00");
      formik.setFieldValue('nextDay', false);
      formik.setFieldValue('stampTime', "");
    }
  }, [formik.values.holidayUnit])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleChangeHoliday = (holidayId: string) => {
    formik.setFieldValue('holidayId', holidayId);
    const tmpSelectedHoliday: any = holidays.filter((holiday: any) => holiday.value === holidayId);
    if (tmpSelectedHoliday[0]) {
      setSelectedHoliday(tmpSelectedHoliday[0]);
      // let unitOptions = [...holidayUnitOptions];
      let unitOptions = getHolidayUnitOption(tmpSelectedHoliday[0]);
      if(!formik.values.achievementId && unitOptions.length > 0){
        formik.setFieldValue('holidayUnit', unitOptions[0].value);
      }
    }
  };
  const handleChangeHolidayUnit = (holidayUnit: string) => {
    formik.setFieldValue('holidayUnit', holidayUnit);
    if ([3, 4].indexOf(formik.values.holidayUnit) !== -1) {
      formik.setFieldValue('halfHolidayStartTimeHour', "00");
      formik.setFieldValue('halfHolidayStartTimeMinute', "00");
      formik.setFieldValue('halfHolidayEndTimeHour', "00");
      formik.setFieldValue('halfHolidayEndTimeMinute', "00");
      formik.setFieldValue('halfHolidayStartTimeNextDay', false);
      formik.setFieldValue('halfHolidayEndTimeNextDay', false);
      }
  };

  useEffect(() => {
    if (selectedSubstitute) {
      formik.setFieldValue('substituteId', selectedSubstitute);
    }

    if (currentApplid.holidayId !== null) {
      handleChangeHoliday(currentApplid.holidayId);
    } else {
      handleChangeHoliday(selectedHoliday.value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentApplid, selectedSubstitute, substituteList, formik.values.substituteId]);

  const columns: Array<Column<AttendHolidayApplicationDomain>> = useMemo(() => [
    {
      Header: 'No',
      accessor: 'version',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.version}
        </div>
      ),
    },
    {
      Header: '申請種別',
      accessor: 'modifiyStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.modifiyStatus == 0 ? '申請' : '削除'}
        </div>
      ),
    },
    {
      Header: '日付',
      accessor: 'targetDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { targetDate && (moment(targetDate).locale('ja').format('YYYY/MM/DD'))}
        </div>
      ),
    },
    {
      Header: '休暇',
      accessor: 'holidayId',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => {
        let holidayItem = holidayOptions.find((elm) => {
          return elm.value == cell.row.original.holidayId
        });
        // console.log(cell.row.original.holidayId, holidayItem);
        return (
          <div style={{ textAlign: 'center' }}>
            {holidayItem?.label}
          </div>
        )
      }
    },
    {
      Header: '休暇単位',
      accessor: 'holidayDigestiveUnit',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.holidayDigestiveUnit != null && cell.row.original.holidayDigestiveUnit == 3 ? '午前休' : cell.row.original.holidayDigestiveUnit != null && cell.row.original.holidayDigestiveUnit == 4 ? '午後休' : cell.row.original.holidayDigestiveUnit == 2 ? '時間休' : '全休'}
        </div>
      ),
    },
    {
      Header: '半休・時間休の開始時間',
      accessor: 'holidayStartHm',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { (cell.row.original.holidayDigestiveUnit == 2 || cell.row.original.holidayDigestiveUnit == 3 || cell.row.original.holidayDigestiveUnit == 4) && cell.row.original.holidayStartHm ? moment(cell.row.original.holidayStartHm, "YYYY/MM/DD HH:mm").locale('ja').format('YYYY/MM/DD HH:mm') : ''}
        </div>
      ),
    },
    {
      Header: '半休・時間休の終了時間',
      accessor: 'holidayEndHm',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { (cell.row.original.holidayDigestiveUnit == 2 || cell.row.original.holidayDigestiveUnit == 3 || cell.row.original.holidayDigestiveUnit == 4) && cell.row.original.holidayEndHm ? moment(cell.row.original.holidayEndHm, "YYYY/MM/DD HH:mm").locale('ja').format('YYYY/MM/DD HH:mm') : ''}
        </div>
      ),
    },
    {
      Header: '取得時間',
      accessor: 'holidayTimes',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.holidayTimes ? cell.row.original.holidayTimes + '時間' : ''}
        </div>
      ),
    },
    {
      Header: '申請日時',
      accessor: 'applicationDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.applicationDate && (moment(cell.row.original.applicationDate).locale('ja').format('YYYY/MM/DD HH:mm:ss'))}
        </div>
      ),
    },
    {
      Header: '申請者',
      accessor: 'applicationStaffName',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.applicationStaffCode ? cell.row.original.applicationStaffCode : ''} {cell.row.original.applicationStaffName ? cell.row.original.applicationStaffName : ''}
        </div>
      ),
    },
    {
      Header: '申請理由',
      accessor: 'applicationReason',
    },
    {
      Header: '決裁状況',
      accessor: 'applicationStatus',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.applicationStatus != null && cell.row.original.applicationStatus == 1 ? '承認' : cell.row.original.applicationStatus == 2 ? '差戻' : '申請中'}
        </div>
      ),
    },
    {
      Header: '決済日時',
      accessor: 'approvalDate',
      Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
        <div style={{ textAlign: 'center' }}>
          { cell.row.original.approvalDate && (moment(cell.row.original.approvalDate).locale('ja').format('YYYY/MM/DD HH:mm:ss'))}
        </div>
      ),
    },
    {
      Header: '差戻コメント',
      accessor: 'rejectReason',
    },
  ], [holidayOptions]);

  const sortBy = React.useMemo(
    () => [
      {
        id: 'no',
        desc: false,
      },
    ],
    [],
  );

  useEffect(() => {
    if (formik.values.holidayUnit !== 2) {
      formik.setFieldValue('startHour', "00");
      formik.setFieldValue('startTime', "00");
      formik.setFieldValue('nextDay', false);
      formik.setFieldValue('stampTime', "");
    }
  }, [formik.values.holidayUnit])

  useEffect(() => {
    var startDate = new Date(holidayStartDate);
    var endDate = new Date(holidayEndDate)
    var target = new Date(targetDate);
 
    if(startDate > target){
      formik.values.halfHolidayStartTimeNextDay = true;
    }
    if(endDate > target){
      formik.values.halfHolidayEndTimeNextDay = true;
    }
  }, [holidayStartDate,holidayEndDate]);

  return (
    <SidebarTemplate pageTitle="休暇申請">
      <BlockUI blocking={isLoading}>
        <div>
          <FormHeader title="休暇申請"/>
          <form onSubmit={formik.handleSubmit}>
            <Container fluid={true}>
              <FormContents customStyle={css({marginTop:'60px'})}>
                <Row style={{ padding: '16px 15px 8px' }}>
                  <Col md={2} xs={12}>
                      <BodyText>日時</BodyText>
                    </Col>
                    <Col md={6} xs={12}>
                      <BodyText color={textColor.mobileTitle}>
                        {moment(`${targetDate}`, 'YYYY-MM-DD').format(`YYYY年MM月DD日(${weekDay[new Date(`${targetDate}`).getDay()]})`)}
                      </BodyText>
                  </Col>
                </Row>
                <Row style={{ padding: '10px 15px' }}>
                  <Col md={2} xs={12}>
                    <BodyText>スタッフ</BodyText>
                  </Col>
                  <Col md={6} xs={12}>
                    <BodyText color={textColor.mobileTitle}>
                      {staffName}
                    </BodyText>
                  </Col>
                </Row>
                <Row className="table-padding">
                  <Table customStyle={styles.container}>
                    <thead>
                      <tr>
                        <Table.HeaderCell customStyle={styles.headerTitle}>休暇</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType1(selectedHoliday.holidayType)}>休暇単位</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType1NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>時間休の開始時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType1NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>取得時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={css([styles.hideByHolidayType1Half(selectedHoliday.holidayType, formik.values.holidayUnit), styles.rangeTimeHalfDay])}>半休となる時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideWithType2(selectedHoliday.holidayType, selectedHoliday.autoGrantHoliday)}>休日出勤日</Table.HeaderCell>
                        {/* <Table.HeaderCell customStyle={styles.hideWithType2NotAuto(selectedHoliday.holidayType, selectedHoliday.autoGrantHoliday)}></Table.HeaderCell> */}
                        {/* <Table.HeaderCell customStyle={styles.hideByHolidayType4(selectedHoliday.holidayType)}></Table.HeaderCell> */}
                        <Table.HeaderCell customStyle={styles.hideByHolidayType5(selectedHoliday.holidayType)}></Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType6(selectedHoliday.holidayType)}>半休となる時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType78(selectedHoliday.holidayType)}>休暇単位</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType78NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>時間休の開始時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={styles.hideByHolidayType78NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>取得時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={css([styles.hideByHolidayType78Half(selectedHoliday.holidayType, formik.values.holidayUnit), styles.rangeTimeHalfDay])}>半休となる時間</Table.HeaderCell>
                        <Table.HeaderCell customStyle={selectedHoliday.holidayType === 2 ? styles.hideByHolidayType2(selectedHoliday.holidayType) :
                          (selectedHoliday.holidayType === 4 ? styles.hideByHolidayType4(selectedHoliday.holidayType) : styles.hideByHolidayType2(selectedHoliday.holidayType))}>
                          休暇単位
                        </Table.HeaderCell>
                        <Table.HeaderCell customStyle={selectedHoliday.holidayType === 2 ? styles.hideByHolidayType2Percent55(selectedHoliday.holidayType) :
                          (selectedHoliday.holidayType === 4 ? styles.hideByHolidayType4Percent55(selectedHoliday.holidayType) : styles.hideByHolidayType2Percent55(selectedHoliday.holidayType))}>
                          半休となる時間
                        </Table.HeaderCell>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <Table.Cell>
                          <VerticalLabelSelectForm
                            label=""
                            name="holidayId"
                            value={String(selectedHoliday.value)}
                            setValue={(val: string) => handleChangeHoliday(val)}
                            options={holidayOptions}
                            required={true}
                            errorMsg={formik.errors.holidayId}
                            disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                          />
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType1(selectedHoliday.holidayType)}>
                          <VerticalLabelSelectForm
                            label=""
                            name="holidayUnit"
                            value={String(formik.values.holidayUnit)}
                            setValue={(val: string) => handleChangeHolidayUnit(val)}
                            options={holidayUnitOptions}
                            disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                          />
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType1NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>
                          <div css={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="startHour"
                                value={String(formik.values.startHour)}
                                setValue={(val: string) => formik.setFieldValue('startHour', val)}
                                options={hourFormOptions}
                                disable={formik.values.holidayUnit !== 2 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="startTime"
                                value={String(formik.values.startTime)}
                                setValue={(val: string) => formik.setFieldValue('startTime', val)}
                                options={timeFormOptions}
                                disable={formik.values.holidayUnit !== 2 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="nextDay"
                                name="nextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.nextDay)}
                                onChange={formik.handleChange}
                                readOnly={formik.values.holidayUnit !== 2 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                              />
                            </div>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType1NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>
                          <div css={{
                            display: 'flex', alignContent: 'center', alignItems: 'center', fontSize: '14px',
                          }}
                          >
                            <Col md={9}>
                              <TextForm
                                name="stampTime"
                                label=""
                                // value={currentApplid.stampTime ? currentApplid.stampTime : ''}
                                value={formik.values.stampTime}
                                onChange={formik.handleChange}
                                disable={formik.values.holidayUnit !== 2 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                              />
                            </Col>
                            <Col md={3} style={{ paddingLeft: '10px' }}>
                              時間
                            </Col>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={css([styles.hideByHolidayType1Half(selectedHoliday.holidayType, formik.values.holidayUnit), styles.rangeTimeHalfDay])}>
                          <div css={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                            {/* Start Time */}
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayStartTimeHour"
                                value={String(formik.values.halfHolidayStartTimeHour)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeHour', val)}
                                options={hourFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayStartTimeMinute"
                                value={String(formik.values.halfHolidayStartTimeMinute)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeMinute', val)}
                                options={timeFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="halfHolidayStartTimeNextDay"
                                name="halfHolidayStartTimeNextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.halfHolidayStartTimeNextDay)}
                                onChange={formik.handleChange}
                                readOnly={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </div>
                            <BodyText customStyle={css({ margin: '0 10px' })}>~</BodyText>
                            {/* End Time */}
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayEndTimeHour"
                                value={String(formik.values.halfHolidayEndTimeHour)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeHour', val)}
                                options={hourFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayEndTimeMinute"
                                value={String(formik.values.halfHolidayEndTimeMinute)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeMinute', val)}
                                options={timeFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="halfHolidayEndTimeNextDay"
                                name="halfHolidayEndTimeNextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.halfHolidayEndTimeNextDay)}
                                onChange={formik.handleChange}
                                readOnly={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </div>
                          </div>
                        </Table.Cell>
                        {/* <Table.Cell customStyle={styles.hideWithType2NotAuto(selectedHoliday.holidayType, selectedHoliday.autoGrantHoliday)}></Table.Cell> */}
                        <Table.Cell customStyle={styles.hideWithType2(selectedHoliday.holidayType, selectedHoliday.autoGrantHoliday)}>
                          <VerticalLabelSelectForm
                            label=""
                            name="substituteId"
                            value={String(formik.values.substituteId)}
                            setValue={(val: string) => {
                              formik.setFieldValue('substituteId', val);
                              setSelectedSubstitute(val);
                            }}
                            options={substituteOptions}
                            disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                          />
                        </Table.Cell>
                        {/* <Table.Cell customStyle={styles.hideByHolidayType4(selectedHoliday.holidayType)}></Table.Cell> */}
                        <Table.Cell customStyle={styles.hideByHolidayType5(selectedHoliday.holidayType)}></Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType6(selectedHoliday.holidayType)}>
                          <div css={{
                            display: 'flex', alignContent: 'center', alignItems: 'center', padding: '1vw', textAlign: 'center',
                          }}
                          >
                            <Col>
                              {selectedHoliday.paidHalfHolidayStartTime}
                              -
                              {selectedHoliday.paidHalfHolidayEndTime}
                            </Col>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType78(selectedHoliday.holidayType)}>
                          <VerticalLabelSelectForm
                            label=""
                            name="holidayUnit"
                            value={String(formik.values.holidayUnit)}
                            setValue={(val: string) => handleChangeHolidayUnit(val)}
                            options={holidayUnitOptions}
                          />
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType78NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>
                          <div css={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="startHour"
                                value={String(formik.values.startHour)}
                                setValue={(val: string) => formik.setFieldValue('startHour', val)}
                                options={hourFormOptions}
                                disable={formik.values.holidayUnit !== 2}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="startTime"
                                value={String(formik.values.startTime)}
                                setValue={(val: string) => formik.setFieldValue('startTime', val)}
                                options={timeFormOptions}
                                disable={formik.values.holidayUnit !== 2}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="nextDay"
                                name="nextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.nextDay)}
                                onChange={formik.handleChange}
                                readOnly={formik.values.holidayUnit !== 2}
                              />
                            </div>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={styles.hideByHolidayType78NotHalf(selectedHoliday.holidayType, formik.values.holidayUnit)}>
                          <div css={{
                            display: 'flex', alignContent: 'center', alignItems: 'center', fontSize: '14px',
                          }}
                          >
                            <Col md={9}>
                              <TextForm
                                name="stampTime"
                                label=""
                                // value={currentApplid.stampTime ? currentApplid.stampTime : ''}
                                value={formik.values.stampTime}
                                onChange={formik.handleChange}
                                disable={formik.values.holidayUnit !== 2}
                              />
                            </Col>
                            <Col md={3} style={{ paddingLeft: '10px' }}>
                              時間
                            </Col>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={css([styles.hideByHolidayType78Half(selectedHoliday.holidayType, formik.values.holidayUnit), styles.rangeTimeHalfDay])}>
                          <div css={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                            {/* Start Time */}
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayStartTimeHour"
                                value={String(formik.values.halfHolidayStartTimeHour)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeHour', val)}
                                options={hourFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayStartTimeMinute"
                                value={String(formik.values.halfHolidayStartTimeMinute)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeMinute', val)}
                                options={timeFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="halfHolidayStartTimeNextDay"
                                name="halfHolidayStartTimeNextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.halfHolidayStartTimeNextDay)}
                                onChange={formik.handleChange}
                                readOnly={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </div>
                            <BodyText customStyle={css({ margin: '0 10px' })}>~</BodyText>
                            {/* End Time */}
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayEndTimeHour"
                                value={String(formik.values.halfHolidayEndTimeHour)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeHour', val)}
                                options={hourFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ padding: '0 5px' }}>:</div>
                            <Col>
                              <VerticalLabelSelectForm
                                label=""
                                name="halfHolidayEndTimeMinute"
                                value={String(formik.values.halfHolidayEndTimeMinute)}
                                setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeMinute', val)}
                                options={timeFormOptions}
                                disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </Col>
                            <div style={{ marginLeft: '10px' }}>
                              <Checkbox
                                id="halfHolidayEndTimeNextDay"
                                name="halfHolidayEndTimeNextDay"
                                label="翌日"
                                value=""
                                checked={Boolean(formik.values.halfHolidayEndTimeNextDay)}
                                onChange={formik.handleChange}
                                readOnly={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              />
                            </div>
                          </div>
                        </Table.Cell>
                        <Table.Cell customStyle={selectedHoliday.holidayType === 2 ? styles.hideByHolidayType2(selectedHoliday.holidayType) :
                          (selectedHoliday.holidayType === 4 ? styles.hideByHolidayType4(selectedHoliday.holidayType) : styles.hideByHolidayType2(selectedHoliday.holidayType))}>
                          <VerticalLabelSelectForm
                            label=""
                            name="holidayUnit"
                            value={String(formik.values.holidayUnit)}
                            setValue={(val: string) => handleChangeHolidayUnit(val)}
                            options={holidayUnitOptions}
                            disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                          />
                        </Table.Cell>
                        <Table.Cell customStyle={selectedHoliday.holidayType === 2 ? styles.hideByHolidayType2Percent55(selectedHoliday.holidayType) :
                          (selectedHoliday.holidayType === 4 ? styles.hideByHolidayType4Percent55(selectedHoliday.holidayType) : styles.hideByHolidayType2Percent55(selectedHoliday.holidayType))}>
                          <div css={{
                            display: 'flex', alignContent: 'center', alignItems: 'center', width: '100%'
                          }}
                          >
                            <div css={{ display: 'flex', alignContent: 'center', alignItems: 'center', width: '100%' }}>
                              {/* Start Time */}
                              <Col>
                                <VerticalLabelSelectForm
                                  label=""
                                  name="halfHolidayStartTimeHour"
                                  disable={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  value={String(formik.values.halfHolidayStartTimeHour)}
                                  setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeHour', val)}
                                  options={hourFormOptions}
                                />
                              </Col>
                              <div style={{ padding: '0 5px' }}>:</div>
                              <Col>
                                <VerticalLabelSelectForm
                                  label=""
                                  name="halfHolidayStartTimeMinute"
                                  disable={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  value={String(formik.values.halfHolidayStartTimeMinute)}
                                  setValue={(val: string) => formik.setFieldValue('halfHolidayStartTimeMinute', val)}
                                  options={timeFormOptions}
                                />
                              </Col>
                              <div style={{ marginLeft: '10px' }}>
                                <Checkbox
                                  id="halfHolidayStartTimeNextDay"
                                  name="halfHolidayStartTimeNextDay"
                                  label="翌日"
                                  value=""
                                  readOnly={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  checked={Boolean(formik.values.halfHolidayStartTimeNextDay)}
                                  onChange={formik.handleChange}
                                />
                              </div>
                              <BodyText customStyle={css({ margin: '0 10px' })}>~</BodyText>
                              {/* End Time */}
                              <Col>
                                <VerticalLabelSelectForm
                                  label=""
                                  name="halfHolidayEndTimeHour"
                                  disable={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  value={String(formik.values.halfHolidayEndTimeHour)}
                                  setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeHour', val)}
                                  options={hourFormOptions}
                                />
                              </Col>
                              <div style={{ padding: '0 5px' }}>:</div>
                              <Col>
                                <VerticalLabelSelectForm
                                  label=""
                                  name="halfHolidayEndTimeMinute"
                                  disable={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  value={String(formik.values.halfHolidayEndTimeMinute)}
                                  setValue={(val: string) => formik.setFieldValue('halfHolidayEndTimeMinute', val)}
                                  options={timeFormOptions}
                                />
                              </Col>
                              <div style={{ marginLeft: '10px' }}>
                                <Checkbox
                                  id="halfHolidayEndTimeNextDay"
                                  name="halfHolidayEndTimeNextDay"
                                  label="翌日"
                                  readOnly={formik.values.holidayUnit === 0 || (currentApplid.applicationStatus === 0 && currentApplid.createDate != null)}
                                  value=""
                                  checked={Boolean(formik.values.halfHolidayEndTimeNextDay)}
                                  onChange={formik.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </Table.Cell>
                      </tr>
                    </tbody>
                  </Table>
                </Row>
                <Row style={{ padding: '10px 30px' }}>
                  <Col md={2} offset={{ md: 1 }} style={{ alignItems: 'center', justifyContent: 'center', display: 'flex', color: textColor.main, fontSize: '14px' }}>申請理由</Col>
                  <Col md={6}>
                    <FormField>
                      <TextForm
                        name="applicationReason"
                        label=""
                        value={String(formik.values.applicationReason)}
                        onChange={formik.handleChange}
                        errorMsg={formik.errors.applicationReason}
                        disable={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                      />
                    </FormField>
                  </Col>
                </Row>
                <Row style={{ padding: '10px 30px' }}>
                  <Col md={6} offset={{ md: 3 }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FormSubmitArea>
                      {
                        (!(currentApplid.modifiyStatus === 1
                          && currentApplid.applicationStatus === 0)) && (
                          <span style={{ marginRight: '12px' }}>
                            <PrimaryButton
                              disabled={currentApplid.applicationStatus === 0 && currentApplid.createDate != null}
                              ghost={false}
                              text="申請する"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('attendType', ActionType.Add);
                              }}
                            />
                          </span>
                        )
                      }
                      {
                        (currentApplid.achievementId !== null
                          && currentApplid.applicationStatus === 0) && (
                          <span style={{ marginRight: '12px' }}>
                            <DeleteButton
                              ghost={false}
                              text="申請キャンセル"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('attendType', ActionType.Modify);
                              }}
                            />
                          </span>
                        )
                      }
                      {
                        (currentApplid.deleteApplicationAvailable === true) && (
                          <span style={{ marginRight: '12px' }}>
                            <DeleteButton
                              ghost={false}
                              text="削除申請"
                              onClick={() => {
                                formik.handleSubmit();
                                formik.setFieldValue('attendType', ActionType.Delete);
                              }}
                            />
                          </span>
                        )
                      }
                    </FormSubmitArea>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} offset={{ md: 3 }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingBottom:'16px' }}>
                    <div style={{ marginRight: '12px' }}>
                      <PrimaryButton
                        onClick={() => history.goBack()}
                        text="キャンセル"
                        ghost={true}
                      />
                    </div>
                  </Col>
                </Row>
              </FormContents>
            </Container>
          </form>
        </div>
      </BlockUI>

      <div style={{ paddingTop: 20 }}>
        <FormContents customStyle={styles.formContent}>
          <Row style={{ padding: '10px 15px' }}>
            <Col
              md={2}
              xs={12}
              style={{
                fontWeight: "bold",
                fontSize: textFontSize.md,
                lineHeight: "24px",
                paddingBottom: "20px",
                color: textColor.main
              }}>
              更新履歴
            </Col>
          </Row>
          <TabControl
            isTabModal={true}
            isFixed={false}
            items={changeLogData.map((log, index: number) => {
              return {
                value: String(index),
                display: `ver${log.version}`
              };
            })}
            setValue={setSelectChangelog as (arg: string) => void}
            currentValue={selectChangelog}
            styleNotActive={css({ borderRadius: 0, border: "none", width: "100px", flex: "unset" })}
            styleActive={css({
              borderRadius: 0,
              border: "none",
              borderBottom: "1px solid #007BC3",
              width: "100px",
              flex: "unset"
            })}
          />
          {
            changeLogData.length > 0 &&
            changeLogData.map((itemLog, index: number) =>
              /** 有給 - 介護休暇 - 子の看護休暇 */
              <div style={{ display: selectChangelog !== String(index) ? "none" : "block" }}>
                <React.Fragment>
                  <FormPadding customStyle={{ fontSize: "14px", color: textColor.mobileTitle }}>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}> 申請種別: </Col>
                      <Col md={10} xs={12}>
                        {itemLog.modifiyStatus == 0 ? "申請" : "削除"}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>申請者:</Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationStaffCode && `${itemLog.applicationStaffCode} `}
                        {itemLog.applicationStaffName && itemLog.applicationStaffName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>申請日時:</Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationDate && moment(itemLog.applicationDate).format("YYYY/MM/DD HH:mm:ss")}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "10px",
                          color: textColor.main
                        }}>出勤組織:</Col>
                      <Col md={10} xs={12}>
                        {itemLog.orgCode && itemLog.orgCode}
                        {itemLog.orgName && itemLog.orgName}
                      </Col>
                    </Row>
                    <Row>
                      <AttendHolidayModal
                        changeLogData={changeLogData}
                        selectChangelog={String(index)}
                        customStyle={styles.approvalWrap}
                      />
                    </Row>
                    <Row>
                      <Col
                        md={2}
                        xs={12}
                        style={{
                          fontWeight: "bold",
                          fontSize: textFontSize.re,
                          lineHeight: "24px",
                          paddingBottom: "20px",
                          color: textColor.main
                        }}>修正理由: </Col>
                      <Col md={10} xs={12}>
                        {itemLog.applicationReason && itemLog.applicationReason}
                      </Col>
                    </Row>
                    {
                      changeLogData.length > 0 && (
                        <Row>
                          <HistoryApprovalTable
                            historyData={itemLog.approvalHistoryList}
                            applicationStatus={itemLog.applicationStatus}
                          />
                        </Row>
                      )
                    }
                  </FormPadding>
                </React.Fragment>
              </div>
            )
          }
        </FormContents>
      </div>

      <ToastModal
        open={toastModalOpen}
        closeHandler={() => setToastModalOpen(false)}
        title={toastMessage}
      />

      <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={() => {
          formik.handleSubmit();
        }}
        title={formik.values.attendType === 0 && currentApplid.achievementId === null ? '休暇を申請'
          : formik.values.attendType === 1 ? '休暇キャンセルを申請' : formik.values.attendType === 2 ? '削除休暇を申請' : '休暇修正を申請'}
        // eslint-disable-next-line no-nested-ternary
        content={formik.values.attendType === 0 && currentApplid.achievementId === null ? '休暇を申請します。よろしいですか？'
          : formik.values.attendType === 1 ? '休暇キャンセルを申請します。よろしいですか？' : formik.values.attendType === 2 ? '削除休暇を申請します。よろしいですか？' : '休暇修正を申請します。よろしいですか？'}
        // eslint-disable-next-line no-nested-ternary
        submitText={'申請する'}
        typeSubmit={formik.values.attendType === 0 && currentApplid.achievementId === null ? 'confirm'
          : formik.values.attendType === 1 ? 'reject' : formik.values.attendType === 2 ? 'reject' : 'confirm'}
      />
    </SidebarTemplate>
  );
};

export default HolidayApplicationPage;
